const Flux = {
  symbol: 'flux',
  color: '#000',
  colorIcon() {
    return `<g fill="none"><circle fill="#2B61D1" cx="16" cy="16" r="16"/><g fill="#FFF"><path d="M17.963 25.862L16 27l-4.218-2.442 1.915-1.109.048-.028.073.042zM25.5 10.5v2.289l-4.152-2.403-1.126-.652-1.126.652-5.278 3.055-1.126.652v1.348l-2.03-1.176-1.127-.652-1.126.652L6.5 15.371V10.5L16 5z"/><path d="M25.5 15.397v6.111l-5.278 3.056-.007-.004-5.27-3.052v-6.11l5.277-3.058zm-12.929 2.582v3.514L9.536 23.25 6.5 21.493v-3.514l3.036-1.758z"/></g></g>`;
  },
  plainIcon: c => {
    return `<path fill-rule="evenodd" fill="${
      c ? c : this.color
    }" d="M16 0c8.837 0 16 7.163 16 16s-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0zm-2.255 23.42l-.048.03-1.915 1.108L16 27l1.963-1.138-4.145-2.399-.073-.042zm6.477-11.08l-5.277 3.057v6.111l5.27 3.052.007.004 5.278-3.056v-6.11l-5.278-3.058zM9.536 16.221L6.5 17.98v3.514l3.036 1.758 3.035-1.758V17.98l-3.035-1.76zM16 5l-9.5 5.5v4.87l1.91-1.105 1.125-.652 1.126.652 2.031 1.176v-1.348l1.126-.652 5.278-3.055 1.126-.652 1.126.652 4.152 2.403v-2.29L16 5z"/>`;
  }
};
export default Flux;
